import React, { createContext, useCallback, useState } from 'react';

import styles from './Gondola.module.scss';
import '@consumer-bootstrap/index.scss';

type GondolaPropsT = {
  children: React.ReactNode;
};

const noop = () => undefined;

// Lets GondolaActionItem close the panel after it runs its own onClick, without every consumer
// having to thread a close callback through its own action handlers.
export const GondolaCloseContext = createContext<() => void>(noop);

export const Gondola: React.FC<GondolaPropsT> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <div className={styles.gondola}>
      <button
        aria-label="Gondola"
        className={styles['toggle-btn']}
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
      >
        <i className="bi bi-train-front-fill" />
      </button>
      {isOpen && (
        <GondolaCloseContext.Provider value={close}>
          <div
            aria-label="Gondola panel"
            aria-modal="true"
            className={styles.panel}
            role="dialog"
          >
            {children}
          </div>
        </GondolaCloseContext.Provider>
      )}
    </div>
  );
};
